import {
  getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdDownload
} from '@/api/generated/company-management-user/company-management-user.ts'
/**
 * Downloads a document via the backend download endpoint.
 * The file is streamed through our own API instead of opening the Azure SAS URL directly,
 * which avoids CORS issues and allows us to use the filename from the database.
 */
export async function downloadDocument(
  serviceModuleId: number,
  employeeUserId: string,
  documentId: string,
  filename?: string | null,
) {
  const response = await getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdDownload(
    serviceModuleId, employeeUserId, documentId
  )
  const url = URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename ?? 'download'
  a.click()
  URL.revokeObjectURL(url)
}
